module.exports = __webpack_public_path__ + "static/media/Statua_045.dfca2b2a.jpg";